import { LegendDefinition } from "./types"
import {
    ElevationVisual,
    FireDangerCAVisual,
    FireDangerUSVisual,
    HeatVisual,
    HotspotAreaVisual,
    HotspotTemperatureVisual,
    ImageOverlapVisual,
} from "./visuals"

const imageOverlapLabels = Array.from({ length: 10 }, (_, i) => String(i + 1))

export const LEGEND_DEFINITIONS: LegendDefinition[] = [
    {
        id: "fireDangerCA",
        title: "Fire Danger (CA)",
        labels: ["Low", "Extreme"],
        Visual: FireDangerCAVisual,
    },
    {
        id: "fireDangerUS",
        title: "Fire Danger (US)",
        labels: ["Low", "Extreme"],
        Visual: FireDangerUSVisual,
    },
    { id: "heat", title: "Heat", labels: ["Low", "High"], Visual: HeatVisual },
    {
        id: "hotspotTemperature",
        title: "Temperature",
        labels: ["Cool", "Hot"],
        Visual: HotspotTemperatureVisual,
    },
    {
        id: "hotspotArea",
        title: "Area",
        labels: ["Small", "Large"],
        Visual: HotspotAreaVisual,
    },
    {
        id: "imageOverlap",
        title: "Images that overlap",
        labels: imageOverlapLabels,
        Visual: ImageOverlapVisual,
    },
    { id: "elevation", title: "Elevation", labels: ["Low", "High"], Visual: ElevationVisual },
]
